import { h } from 'preact';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'preact/hooks';

import { authStore } from '../../../global-store/subjects/auth';
import { useSubscribe } from '../../hooks/use-subscribe';
import Wrapper from '../../components/1-foundation/wrapper/wrapper';
import { getSvgImgSrc } from '../../../utils/string-utils';
import { getHandleSlimBannerPersonalizationClick } from '../../utils/slim-banner';
import BannerMarketing from '../../components/3-molecules/banner-marketing/banner-marketing';
import BannerMarketingSkeleton from '../../components/3-molecules/banner-marketing/banner-marketing-skeleton';
import SectionDivider from '../../components/3-molecules/section-divider/section-divider';
import { modifierList as iconsModifiersList } from '../../components/1-foundation/icons/props-list';

const SlimBannerHPPersonalization = ({ htmlProps, widget, parselyStoreSubscriptions }) => {
  const { isUserLogged, isLoginLoading } = useSubscribe(authStore);
  const [preferenceName, setPreferenceName] = useState();
  const [isWidgetLoading, setIsWidgetLoading] = useState(true);

  const bannerModifiers = ['slim'];
  const skeletonModifiers = ['cta'];
  const sectionDividerModifiers = ['secondary-light', 'full'];
  const isLoading = isLoginLoading || isWidgetLoading;
  const parselyStoreSubscription = parselyStoreSubscriptions[htmlProps.widgetId];
  const parselyState = parselyStoreSubscription();

  useEffect(() => {
    if (!parselyState.isLoading) {
      setIsWidgetLoading(false);
      setPreferenceName(parselyState.userPreferences[0]?.name);
    }
  }, [parselyState.isLoading, parselyState.userPreferences]);

  const renderMarketingText = () => {
    const preLoginText = htmlProps.preLoginText;
    const postLoginText = preferenceName
      ? htmlProps.postLoginTextWithPreferences.replace(/%s/i, preferenceName)
      : htmlProps.postLoginText;
    return isUserLogged ? postLoginText : preLoginText;
  };

  const text = renderMarketingText();

  return (
    <Wrapper
      tag="a"
      href="#"
      isWrapping={!isLoading}
      onClick={getHandleSlimBannerPersonalizationClick({
        isUserLogged,
        widgetId: htmlProps.widgetId,
        widgetTab: htmlProps.widgetTab,
      })}
      role="button"
      aria-label={text}
    >
      <SectionDivider modifiers={sectionDividerModifiers}>
        <div className="l-inner-grid">
          <div className="l-inner-grid__main">
            {isLoading && (
              <BannerMarketingSkeleton
                skeletonColor={widget.styles.skeletonColor}
                bannerModifiers={bannerModifiers}
                skeletonModifiers={skeletonModifiers}
              />
            )}
            {!isLoading && (
              <BannerMarketing
                imgSrc={isUserLogged ? getSvgImgSrc(htmlProps.logo) : ''}
                text={renderMarketingText()}
                modifiers={bannerModifiers}
                showArrowIcon={!isUserLogged}
                iconsColor={widget.styles.iconsColor}
              />
            )}
          </div>
        </div>
      </SectionDivider>
    </Wrapper>
  );
};

SlimBannerHPPersonalization.propTypes = {
  htmlProps: PropTypes.shape({
    widgetId: PropTypes.string.isRequired,
    widgetTab: PropTypes.string.isRequired,
    preLoginText: PropTypes.string.isRequired,
    postLoginText: PropTypes.string.isRequired,
    postLoginTextWithPreferences: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired,
  }),
  widget: PropTypes.shape({
    name: PropTypes.string.isRequired,
    htmlId: PropTypes.string.isRequired,
    styles: PropTypes.shape({
      skeletonColor: PropTypes.string.isRequired,
      iconsColor: PropTypes.oneOf(iconsModifiersList).isRequired,
    }).isRequired,
  }).isRequired,
  parselyStoreSubscriptions: PropTypes.object.isRequired,
};

export default SlimBannerHPPersonalization;
